import MissingOnSave from '../exceptions/missing_on_save'

class Relation {
  #linkable_id
  #linkable_type
  constructor(rel) {
    this.rel = rel
  }
  get linkable_id() {
    return this.#linkable_id
  }
  get linkable_type() {
    return this.#linkable_type
  }
  set rel({ linkable_id, linkable_type }) {
    if (!linkable_id) throw MissingOnSave('linkable_id', 'relation')
    if (!linkable_type) throw MissingOnSave('linkable_type', 'relation')
    this.#linkable_id = linkable_id
    this.#linkable_type = linkable_type
    return this
  }
  toJSON() {
    return {
      linkable_id: this.linkable_id,
      linkable_type: this.linkable_type,
    }
  }
}

export default Relation
